<template>
  <section id="WomensSafety">
    <h3>Women's Safety Initiative</h3>
    <p>On Women's Day 2020, Truecaller launched '#ItsNOTOK - Against Harassment' to share the research and stories behind SMS and call harassment.</p>
    <div id="WomensSafetyInfo">
      <div>
        <img src="@/assets/icons/stat-1-icon.svg">
        <p>9 out of 10 women receive harassment & nuisance calls in Brazil</p>
      </div>
      <div>
        <img src="@/assets/icons/stat-2-icon.svg">
        <p>8 out of 10 women receive harassment & nuisance calls in India</p>
      </div>
    </div>
    <a
      href="https://youtu.be/5BMPgqcLepE"
      target="_blank"
      rel="noreferrer, noopener"
      class="button button--white"
      @click="$gtag.event('clicked_against_harassment_video', {
        'event_category' : 'outbound',
        'event_label' : 'against_harassment_video'
      })"
    >
      <img src="@/assets/icons/play-icon.svg">
      See the video
    </a>
  </section>
</template>

<script>
export default {};
</script>

<style>
#WomensSafety {
  background-image: linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)),
    url("../assets/images/year_in_calling_truecaller_2020_3.png");
  background-size: cover;
  background-position: center center;
  padding: 48px 20px;
}
#WomensSafety h3 {
  font-size: 24px;
  line-height: 29px;
  letter-spacing: -0.72px;
  margin-bottom: 12px;
}
#WomensSafety p {
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 0;
}
#WomensSafetyInfo {
  display: flex;
  flex-flow: column;
}
#WomensSafetyInfo > div {
  padding: 20px;
  max-width: 420px;
}
#WomensSafetyInfo > div > img {
  margin-bottom: 12px;
}

#WomensSafety .button {
  max-width: 175px;
}

@media screen and (min-width: 720px) {
  #WomensSafety h3 {
    font-size: 60px;
    line-height: 73px;
    letter-spacing: -1.8px;
    margin-bottom: 12px;
  }
  #WomensSafety p {
    font-size: 18px;
    line-height: 32px;
    margin-bottom: 0;
  }
  #WomensSafetyInfo {
    flex-flow: row;
  }
}
</style>